// @flow
import React from 'react';
import NewsList from 'Plugins/NewsList';

type Props = {
  newsList: Array<Object>,
};

export default class TopNewsEvents extends React.Component<Props> {
  static defaultProps = {
    newsList: [],
  };

  render() {
    const { newsList } = this.props;

    return newsList.length > 0 ? <NewsList newsList={newsList} /> : null;
  }
}
